import { render, staticRenderFns } from "./ui-mole-view.vue?vue&type=template&id=799a9a54&"
import script from "./ui-mole-view.vue?vue&type=script&lang=js&"
export * from "./ui-mole-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports